import { IDriverConstraints, IStopConstraints } from './interfaces';

export const driverConstraints: IDriverConstraints = {
  weight: [12, 15, 25],
  volume: [40, 60, 100],
  time_windows: [`07:00-16:00`, `07:00-16:00`, `07:00-16:00`],
};
export const stopConstraints: IStopConstraints = {
  weight: [3, 5, 5, 1, 5, 10, 3, 3, 5, 1],
  volume: [10, 20, 20, 20, 5, 10, 20, 5, 20, 10],
  time_windows: [
    `10:00-12:00`,
    `10:00-12:00`,
    `10:00-12:00`,
    ``,
    `08:00-10:00`,
    `08:00-10:00`,
    `12:00-14:00`,
    `11:00-12:00`,
    `10:00-15:00`,
    `10:00-15:00`,
  ],
};
